<template>
	<select  v-model="value" class="form-control" :name="name" :disabled="disabled">
		<option v-for="item in formatted" :value="item.val">{{item.name}}</option>
	</select>
</template>

<script>
	export default {
		name: 'bsf-select',
		components: {},
		props: {
			data: {
				type: Array
			},
			disabled: {
				type: Boolean,
				default: false
			},
			multiple: {
				type: Boolean,
				default: false
			},
			name: {
				type: String
			},
			sname: {
				type: String
			},
			sval: {
				type: String
			}
		},
		data: function() {
			return {
				value:""
			}
		},
		mounted: function() {
			this.$nextTick(function() {

			})
		},
		computed: {
			setDis() {
				return this.disabled ? "disabled" : "";
			},
			isInline() {
				return this.direction ? "form-" + this.direction : "";
			},
			formatted() {
				let data = []
				this.data.forEach(item => {
					data.push({
						name: item[this.sname],
						val: item[this.sval]
					})
				})
				return data
			}
		},
		watch: {
			value(v) { // 选中的值改变的时候 $emit 回去给父级
				this.$emit('selected', v)
			}
		}
	}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	@import (reference) "../../../assets/lib/css.less";
</style>


// WEBPACK FOOTER //
// select.vue?1b30e27d